const GRADE_LIST = [
    { code: 'grade_a', isLegacy: false },
    { code: 'grade_b', isLegacy: false },
    { code: 'grade_c', isLegacy: false },
    { code: 'grade_d', isLegacy: false },
    { code: 'grade_ab', isLegacy: true },
    { code: 'grade_bc', isLegacy: true },
    { code: 'grade_cd', isLegacy: true },
    { code: 'grade_abc', isLegacy: true },
    { code: 'grade_abcd', isLegacy: true },
    { code: 'grade_unknown', isLegacy: false },
];
export const GRADES = GRADE_LIST.map(grade => ({
    isLegacy: grade.isLegacy,
    key: grade.code,
    label: `resource.auction.properties.grade.code.options.${grade.code}`,
}));
